import {Link} from 'react-router-dom';

function Projects(props) {

    const projects = [
      {
        id: 1,
        title: 'Mason Stoops: Session Guitarist',
        link: 'https://dylicious2020.github.io/masonStoops/'
      },
      {
        id: 2,
        title: 'Sam McCabe: Indie Artist',
        link: 'https://dylicious2020.github.io/sammccabe/'
      }
    ]

    const projectsMap = 
<div
    style={{
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '20px',
      justifyContent: 'center',
    }}
  >
    {projects.map((p) => (
      <div key={p.link}>
        <a href={p.link} className='link2' style={{
          color: props.mode === 'light' ? '#28282b' : '#f1eee6'
        }}>
          <div style={{
          color: props.mode === 'light' ? '#28282b' : '#f1eee6',
          transition: '.5s',
          textDecoration: 'none',
          cursor: 'pointer',
          fontSize: '25px',
          fontWeight: '100',
          paddingBottom: '10px',
          width: '100%',
          textAlign: 'center'
        }}>{p.title}</div>
        </a>
        <iframe
          src={p.link}
          title={p.title}
          style={{
            borderRadius: '12px',
            border:
              props.mode === 'light'
                ? '1px solid #28282b'
                : '1px solid #f1eee6',
            width: '370px',
            height: '500px',
          }}
        />
      </div>
    ))}
  </div>


 
    
    return (
        <div style={{
          paddingTop: '50px'
        }}>
          {projectsMap}
      <div className='bodyContainer'>
    
      </div>
      </div>
      );
}

export default Projects